export const Options = {
     BecomingAwareThrough: [
        { text: "Karriere-Website der Stadtwerke Speyer",value:"Karriere-Website der Stadtwerke Speyer"},
        { text: "Mitarbeitende der Stadtwerke Speyer",value:"Mitarbeitende der Stadtwerke Speyer"},
        { text: "Freunde/Bekannte/Familie",value:"Freunde/Bekannte/Familie"},
        { text: "Social Media (Facebook, Instagram etc.)",value:"Social Media (Facebook, Instagram etc.)"},
        { text: "Agentur für Arbeit",value:"Agentur für Arbeit"},
        { text: "Google-Suche",value:"Google-Suche"},
        { text: "StepStone",value:"StepStone"},
        { text: "LinkedIn",value:"LinkedIn"},
        { text: "Zeitung",value:"Zeitung"},
        { text: "Ausbildungs- oder Jobmesse",value:"Ausbildungs- oder Jobmesse"},
        { text: "Ausbildung.de",value:"Ausbildung.de"},
        { text: "Azubiyo.de",value:"Azubiyo.de"},
        { text: "Aubi-Plus.de",value:"Aubi-Plus.de"},
        { text: "Studyflix/Studysmarter",value:"Studyflix/Studysmarter"},
        { text: "Sonstiges",value:"Sonstiges"},
    ]}
